import { render } from "./HeaderDashboard.vue?vue&type=template&id=77884fd6"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__